import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
  useContext
} from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Dash1, Dash2, Dash3, Dash4, Noimage } from "../../../common/imagePath";
import CountUp from "react-countup";
import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import LookupReceiptModal from "../../../components/Modal/LookupReceiptModal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";
import * as XLSX from "xlsx";

import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import { Box, Button, MenuItem } from "@mui/material";
import { checkUserPermission } from "../../../common/UserPermission";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import DeleteIcon from "@mui/icons-material/Delete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { handleSaveColumnOrder } from "../../../common/common";
import CommonMatrialReactTableServerSideRender from "../../../components/Datatable/CommonMatrialReactTableServerSideRender";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
// { useContext } from "react";

const Receiving = (onMarkAsPaid) => {
  const { CurrencySymbol, FractionDigits, dateFormate, isManageReceiving, isManagePOSReceiving } = useContext(AppContext);
  const locationData = useLocation();
  const { isManageSale, isManagePOSSale } = useContext(AppContext);
  let selectData = [];
  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");
  const [perPageSize, setperPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedReceivingCheckboxIds, setselectedReceivingCheckboxIds] =
    useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [recevingSummary, setRecevingSummary] = useState();
  const [receivePaymentStatus, setReceivePaymentStatus] = useState(0);
  const [rectype, setRectype] = useState([
    {
      ID: Number,
      SalesType: String,
    },
  ]);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [recoptions, setRecOptions] = useState([
    {
      Id: Number,
      CompanyName: String,
      FirstName: String,
      LastName: String,
      Email: String,
      PhoneNumber: Number,
      Address1: String,
      City: String,
      StateProvince: String,
      Zip: Number,
      Country: String,
    },
  ]);
  const [receivingTypeValue, setreceivingTypeValue] = useState();
  const [supplierValue, setsupplierValue] = useState();
  const [receivingTypeID, setReceivingTypeID] = useState(0);
  const [supplierID, setSupplierID] = useState(0);
  const [startingDate, setStartingDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [endingDate, setEndingDate] = useState(moment().format("YYYY-MM-DD"));
  const [customStartingDate, setCustomStartingDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [customEndingDate, setCustomEndingDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [showSearchBar, setShowSearchBar] = useState();
  const [status, setStatus] = useState(0);
  const [quickbookarray, setQuickbookArray] = useState([]);

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "Last 7 Day",
    value: 7,
  });

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  console.log(rowCount , "rowCount13246")

  //table state
  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([{ id: "ReceivingId", desc: true }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  console.log(columnVisibility, "columnVisibility");

  let PERMISSION_DELETE = "receiving-batch-delete";
  let PERMISSION_EDIT = "/manage-receiving/:id";
  let PERMISSION_ADD = "/manage-receiving";
  let PERMISSION_RECEIPT = "/receiving-receipt/:id";
  let PERMISSION_PAYBILLS = "/receiving-paybills";
  let PERMISSION_TRANSFER = "/transfer-request/:id";
  let PERMISSION_INCOMING = "/suspended-receiving/:id";
  let PERMISSION_PURCHASE = "/create-purchase-orders";
  let PERMISSION_LASTRECEIVING = "/receiving-receipt";
  let PERMISSION_BATCHRECEIVING = "/batch-receiving";
  let PERMISSION_CUSTOMFIELD = "/receiving-custom-field";

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_File.xlsx`);
  };

  const handleExportAllReceivings = () => {
    const FilterColumnText = {};
    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    axios
      .get(
        `${
          config.receivingBaseUrl
        }/receivings/listofalldata?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=1&pagesize=0&filtertext=&ordercolumn=ReceivingId&currentorder=desc&startdate=''&enddate=''&receivingtypeid=0&supplierid=0&status=0&LocationID=${localStorage.getItem(
          "Location"
        )}&receivePaymentStatus=0&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("listofsuspendrecord", res.data.ResponseData?.list);
        const receivingsAllRecords = res.data.ResponseData?.list;
        const workbook = XLSX.utils.book_new();

        console.log(receivingsAllRecords,"receivingsAllRecords");
  
        let Data = [];
        Data = receivingsAllRecords;
  
        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(Data);
  
        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, `All_Receivings_Exel_File.xlsx`);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  console.log(pagination, "pagination");
  console.log(columnOrder, "columnOrder");
  //status
  const statusoption = [
    { label: "All", value: 0 },
    { label: "Completed", value: 2 },
    { label: "Paid", value: 4 },
    { label: "Pending", value: 1 },
    { label: "Rejected", value: 3 },
  ];

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "Posid",
      // accessorKey: "ReceivingId",
      size: 100,
      Cell: (checkUserPermission(PERMISSION_EDIT) || checkUserPermission("/pos-receiving"))
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() =>
                navigate(`/receiving-receipt/${row.original.Posid}`)
              }
            >
              <span
            style={{
              display: "inline-block",
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: row.original.SyncStatusName === "Completed" ? "green" : "red",
              marginRight: "8px",
            }}
            ></span>
              {row.original.Posid}
            </Box>
          )
        : null,
      filterFn: "contains",
    },
    {
      header: "Last Updated",
      accessorKey: "LastUpdatedDate",
     size : 160,
      Cell: ({ row }) =>
        moment(row.original.LastUpdatedDate).format(`${dateFormate.toUpperCase()} h:mm A`),
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      size : 160,
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format(`${dateFormate.toUpperCase()} h:mm A`),
      positionActionsColumn: "last",
      // enableGrouping: false, //do not let this column be grouped
    },
    // {
    //   header: "Modified Date",
    //   accessorKey: "ModifiedDate",
    //   Cell: ({ row }) =>
    //     moment(row.original.ModifiedDate).format("MM/DD/YYYY h:mm A"),
    //   positionActionsColumn: "last",
    //   // enableGrouping: false, //do not let this column be grouped
    // },
    {
      header: "Type",
      accessorKey: "ReceiveType",
      size : 120,
      // filterVariant: 'multi-select',
      // filterSelectOptions: rectype.map((option)=>option.ReceivingsType),
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      size : 130,
      //   Cell: checkUserPermission(PERMISSION_EDIT)
      //   ? ({ row }) => (
      //       <Box
      //         component="span"
      //         sx={(theme) => ({
      //           borderRadius: "0.3rem",
      //           color: "#343f62",
      //           maxWidth: "18ch",
      //           fontWeight:"700",
      //           textDecoration:"underline",
      //           textUnderlineOffset: "3px",
      //           p: "0.3rem",
      //           cursor: "pointer",
      //         })}
      //         onClick={() =>
      //           navigate(`/manage-employee/${loginuserid}`)
      //         }
      //       >
      //         {row.original.CreatedBy}
      //       </Box>
      //     )
      //   : null,
      // filterFn: "contains",
    },
    {
      header: "Status",
      accessorKey: "StatusName",
      size : 130,
      // filterVariant: 'multi-select',
      // filterSelectOptions: statusoption.map((option)=>option.label),
      Cell: ({ row }) =>
        row.original.StatusName == "Paid" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "18ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.StatusName}
          </Box>
        ) : row.original.StatusName == "Completed" ? (
          <Box
            component="span"
            sx={(theme) => ({
              // backgroundColor: 'var(--primary-color-50)',
              borderRadius: "0.3rem",
              color: "var(--neutral-main-color)",
              maxWidth: "18ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.StatusName}
          </Box>
        ) : row.original.StatusName == "Pending" ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "18ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.StatusName}
          </Box>
        ) : row.original.StatusName == "Rejected" ? (
          <Box
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#FBECF0',
              borderRadius: "0.3rem",
              color: "#E5AAB7",
              maxWidth: "18ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.StatusName}
          </Box>
        ) : (
          ""
        ),
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Receiving Date",
      accessorKey: "Date",
      size : 130,
      Cell: ({ row }) => moment(row.original.Date).format(`${dateFormate.toUpperCase()}`),
      positionActionsColumn: "last",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Supplier",
      accessorKey: "Supplier",
      // size : 180,
      // filterVariant: 'multi-select',
      // filterSelectOptions: recoptions.map((option)=>option.CompanyName +" (" + option.FirstName + " " + option.LastName +")"),
      Cell: ({ row }) => (
        <Box
          // class="text-warning word-break-data"
          // to={`/manage-suppliers/${row.original.SupplierId}`}
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() =>
            navigate(`/manage-suppliers/${row.original.SupplierId}`)
          }
        >
          {row.original.Supplier}
        </Box>
      ),
      // enableGrouping: false, //do not let this column be grouped
    },
    
    // {
    //   header: "Paid Amount",
    //   accessorKey: "AmountPaid",
    //   size : 130,
    //   Cell: ({ row }) => {
    //     return CurrencySymbols(
    //       Number(row.original.AmountPaid),
    //       CurrencySymbol,
    //       FractionDigits
    //     );
    //   },
    // },
    // {
    //   header: "Credit Applied",
    //   accessorKey: "CreditApplied",
    //   cell: ({ row }) => row.original.CreditApplied,
    //   size: 100,
    // },
    {
      header: "Balance",
      size : 130,
      accessorKey: "AmountDue",
      // cell: ({ row }) => row.original.AmountDue,
     Cell: ({ row }) => {
        return CurrencySymbols(
          Number(row.original.AmountDue),
          CurrencySymbol,
          FractionDigits
        );
      },
    },
    {
      header: "Amount",
      // header: "Bill Amount",
      accessorKey: "Total",
      size : 130,
      // cell: ({ row }) => Number(row.original.Total).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})
      Cell: ({ row }) => {
        return CurrencySymbols(
          Number(row.original.Total),
          CurrencySymbol,
          FractionDigits
        );
      },
    },
    {
      header: "Comments",
      accessorKey: "Comments",
      cell: ({ row }) => row.original.Comments,
    },
    {
      header: "Location",
      accessorKey: "Location",
      size: 140,
      cell: ({ row }) => row.original.Location,
    },
    {
      header: "BILL / REF NO.",
      accessorKey: "ReferenceNo",
      size: 140,
    },
    {
      header: "QB SYNC",
      accessorKey: "SyncStatusName",
      size : 120,
      Cell: ({ row }) => {
        const commonStyle = {
          borderRadius: "0.3rem",
          maxWidth: "10ch",
          p: "0.3rem",
          fontWeight: "bold",
        };

        return row.original.ReceivingTypeId === 4 ? (
          <Box
            component="span"
            sx={{
              ...commonStyle,
              color: "var(--success-main-color)",
            }}
          >
            Not Applicable
          </Box>
        ) : (
          <Box
            component="span"
            sx={{
              ...commonStyle,
              color:
                row.original.SyncStatusName === "Completed"
                  ? "var(--success-main-color)"
                  : "var(--error-main-color)",
            }}
          >
            {row.original.SyncStatusName === "Completed" ||
            row.original.SyncStatusName === "Failed"
              ? row.original.SyncStatusName
              : ""}
          </Box>
        );
      },

      // enableGrouping: false, //do not let this column be grouped
    },
  ]);

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate,
    receivingtypeid,
    supplierid,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    status
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        count: el.id === "Supplier" ? el.value.length : 0,
        ismultiple: el.id === "Supplier" ? 1 : 0,
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    supplierid = supplierid > 0 ? supplierid : 0;
    receivingtypeid = receivingtypeid > 0 ? receivingtypeid : 0;
    startingdate = startingdate === undefined ? "" : startingdate;
    endingdate = endingdate === undefined ? "" : endingdate;

    console.log(
      quickBookOptions?.value,
      startingdate,
      endingdate,
      "check receiving Data"
    );

    if (
      quickBookOptions?.value !== 1 &&
      startingdate === "" &&
      endingdate === ""
    ) {
      setLoading(false);
      return;
    }

    axios
      .get(
        `${
          config.receivingBaseUrl
        }/receivings/listofalldata?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&startdate=${startingdate}&enddate=${endingdate}&receivingtypeid=${receivingtypeid}&supplierid=${supplierid}&status=${status}&LocationID=${localStorage.getItem(
          "Location"
        )}&receivePaymentStatus=${receivePaymentStatus}&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("listofsuspendrecord", res.data.ResponseData?.list);
        console.log("listofsuspendrecord", res.data.ResponseData?.list[0]?.TotalRecord);
        setData(res.data.ResponseData?.list);
        setTotalRows(res.data.ResponseData?.list[0]?.TotalRecord);
        setRowCount(res.data.ResponseData?.list[0]?.TotalRecord);

        console.log(res.data.ResponseData?.list[0]?.TotalRecord , 'check total record123')
        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);

        // setColumnVisibility("");
        setLoading(false);

        localStorage.removeItem("DashboardTypeFilterstatus");
        localStorage.removeItem("DashboardTypeFiltertype");
        localStorage.removeItem("DashboardTypeFiltersalePaymentStatus");
        localStorage.removeItem("DashboardTypeFilter");
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    console.log(localStorage.getItem("DashboardTypeFilter"), "testuuu 1");
    if (localStorage.getItem("DashboardTypeFilter")) {
      console.log(localStorage.getItem("DashboardTypeFilter"), "testuuu 2");
      setStatus(localStorage.getItem("DashboardTypeFilter"));
    }

    if (localStorage.getItem("DashboardTypeFilterstatus")) {
      console.log(
        localStorage.getItem("DashboardTypeFilterstatus"),
        "testuuu 2"
      );
      setStatus(localStorage.getItem("DashboardTypeFilterstatus"));
    }

    console.log(localStorage.getItem("DashboardTypeFiltertype"), "testuuu 1");
    if (localStorage.getItem("DashboardTypeFiltertype")) {
      console.log(localStorage.getItem("DashboardTypeFiltertype"), "testuuu 2");
      setReceivingTypeID(localStorage.getItem("DashboardTypeFiltertype"));
    }

    if (localStorage.getItem("DashboardTypeFiltersalePaymentStatus")) {
      console.log(
        localStorage.getItem("DashboardTypeFiltersalePaymentStatus"),
        "testuuu 2"
      );
      setReceivePaymentStatus(
        localStorage.getItem("DashboardTypeFiltersalePaymentStatus")
      );
    }
  }, []);

  useEffect(() => {
    // if (quickBookOptions?.value !== 2) {
    console.log("check api call");
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      receivingTypeID,
      supplierID,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      status
    );
    // }
  }, [
    receivingTypeID,
    supplierID,
    status,
    quickBookOptions,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
  ]);

  const handleDeletePopup = (id, quickbookid, receivingtypeid, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    let rowdata = [];
    // let receivingtype;
    // let receivingtypeid=[];

    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ReceivingId).join(",");
      rowdata = rows.map((el) => {
        return {
          quickbookid: el.original.QuickbookId,
          type: el.original.ReceivingTypeId,
        };
      });
      // setQuickbookArray(rowdata)
    } else {
      data = id;
      const obj = {
        quickbookid: quickbookid,
        type: receivingtypeid,
      };
      rowdata.push(obj);
    }

    const deleteRequestParam = {
      receivingids: data,
      loginuserid: loginuserid,
      locationid: location,
      quickbookarray: rowdata,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  const contextActions = useMemo(() => {
    const handleDeletePopup = () => {
      const deleteRequestParam = {
        receivingids: selectedReceivingCheckboxIds,
        loginuserid: loginuserid,
        locationid: location,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  console.log(data, "table Data");

  const handleChangeStatus = (e) => {
    setStatus(e?.value);
  };

  // fatch and display data on page load ===> ashish
  useEffect(() => {
    axios
      .get(`${config.receivingBaseUrl}/receivings/receivingtypedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("Receving Types", response.data.ResponseData);
        setRectype(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    // customer drop down
    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        setRecOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `${
          config.receivingBaseUrl
        }/receivings/receivingsummary?locationid=${localStorage.getItem(
          "Location"
        )}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("receiving summary", response.data.ResponseData[0]);
        setRecevingSummary(response.data.ResponseData[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
    { label: "Last 7 Day", value: 7 },
  ];

  const handleChangeCustomStartingDate = (event) => {
    // console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event);
    setStartingDate(event);
  };

  // const handleChangeCustomStartingDate = (selectedDate) => {
  //   if (selectedDate && selectedDate.length > 0) {
  //     const datetime =
  //       moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
  //     const settime = moment(datetime).format("YYYY-MM-DD");
  //     console.log(settime, "settime");
  //     setCustomStartingDate(settime);
  //     setStartingDate(settime);
  //   }
  // };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event);
    setEndingDate(event);
  };

  // const handleChangeCustomEndingDate = (selectedDate) => {
  //   if (selectedDate && selectedDate.length > 0) {
  //     const datetime =
  //       moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
  //     const settime = moment(datetime).format("YYYY-MM-DD");
  //     console.log(settime, "settime");
  //     setCustomEndingDate(settime);
  //     setEndingDate(settime);
  //   }
  // };

  const supplierDropDown = recoptions.map((option) => ({
    value: option.ID,
    // label: option.FirstName + " " + option.LastName,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address,
    PhoneNumber: option.PhoneNumber
  }));

  const handleQuickBookChange = (event) => {
    // event?.value !== 2 && handleSearchAccordingToDate();

    setQuickBookOptions(event);

    console.log(event, "quick book data");

    // All Condition
    if (event?.value == 1) {
      const startYearDate = moment().startOf("year").format("YYYY-MM-DD");
      const endYearDate = moment().endOf("year").format("YYYY-MM-DD");
      setStartingDate(startYearDate);
      setEndingDate(endYearDate);
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else if (quickBookOptions?.value == 7) {
      const startLast7DayDate = moment()
        .subtract(7, "days")
        .startOf("day")
        .format("YYYY-MM-DD");
      const endLast7DayDate = moment().endOf("day").format("YYYY-MM-DD");
      setStartingDate(startLast7DayDate);
      setEndingDate(endLast7DayDate);
    } else {
      const startYearDate = moment().startOf("year").format("YYYY-MM-DD");
      const endYearDate = moment().endOf("year").format("YYYY-MM-DD");
      setStartingDate(startYearDate);
      setEndingDate(endYearDate);
    }
  };

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      const startYearDate = moment().startOf("year").format("YYYY-MM-DD");
      const endYearDate = moment().endOf("year").format("YYYY-MM-DD");
      setStartingDate(startYearDate);
      setEndingDate(endYearDate);
    }
    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //current Month
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    }
    //last 7 day
    else if (quickBookOptions?.value == 7) {
      const startLast7DayDate = moment()
        .subtract(7, "days")
        .startOf("day")
        .format("YYYY-MM-DD");
      const endLast7DayDate = moment().endOf("day").format("YYYY-MM-DD");
      setStartingDate(startLast7DayDate);
      setEndingDate(endLast7DayDate);
    } else {
      const startYearDate = moment().startOf("year").format("YYYY-MM-DD");
      const endYearDate = moment().endOf("year").format("YYYY-MM-DD");
      setStartingDate(startYearDate);
      setEndingDate(endYearDate);
    }
  }, [quickBookOptions]);

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      receivingTypeID,
      supplierID,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      status
    );
  };

  const handleChangeReceivingType = (event) => {
    setreceivingTypeValue(event);
    setReceivingTypeID(event?.value);
  };

  const handleChangeSupplier = (event) => {
    console.log(event);
    setsupplierValue(event);
    setSupplierID(event?.value);
  };
  const datafilter = rectype.filter((el) => el?.ReceivingsType !== "Expense");
  let receivingTypeDropdownOption = [];
  const ReceivingTypeDropdown = datafilter.map((u, i) => {
    receivingTypeDropdownOption[i] = { label: u.ReceivingsType, value: u.ID };
  });

  const renderRowActionMenuItems = ({ row }) => [
    checkUserPermission(PERMISSION_PAYBILLS) && row.original.ReceiveType === "Receive" ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"
        onClick={() => {
          localStorage.setItem("paybillSupplierid", row.original.SupplierId);
          navigate("/receiving-paybills");
        }}
      >
        Mark As Paid
      </MenuItem>
    ) : (
      ""
    ),

    (checkUserPermission(PERMISSION_EDIT) || checkUserPermission("/pos-receiving")) ? (
      row.original.ReceivingTypeId == 4 && row.original.Status == 2 ? (
        ""
      ) : (
        <MenuItem
          key="edit"
          onClick={() =>
            navigate(
              isManageReceiving == 1 ? `/manage-receiving/${row.original.ReceivingId}`
              : isManagePOSReceiving == 1 ? `/pos-receiving/${row.original.ReceivingId}` : "#")
          }
        >
          Edit
        </MenuItem>
      )
    ) : (
      ""
    ),

    checkUserPermission(PERMISSION_DELETE) ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"

        // title="Delete"
        // data-bs-toggle="modal"
        // data-bs-target="#DeleteConfirmationModal"
        onClick={() =>
          handleDeletePopup(
            row.original.ReceivingId,
            row.original.QuickbookId,
            row.original.ReceivingTypeId,
            row.original.SupplierId,
            "",
            ""
          )
        }
      >
        Delete
      </MenuItem>
    ) : (
      ""
    ),

    checkUserPermission(PERMISSION_RECEIPT) ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"
        onClick={() => navigate(`/receiving-receipt/${row.original.Posid}`)}
      >
        Receipt
      </MenuItem>
    ) : (
      ""
    ),
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "0.2rem",
        p: "0.5rem",
        flexWrap: "wrap",
        width: "70%",
        marginLeft: "30px",
      }}
    >
      {console.log(table, "tables")}

      {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) &&
      checkUserPermission(PERMISSION_DELETE) ? (
        <Button
          // size="small"
          class="btn btn-sm btn-secondary"
          style={{ display: "flex" }}
          // disabled={
          //   !table.getIsSomeRowsSelected() &&
          //   !table.getIsAllRowsSelected()
          // }
          onClick={() =>
            handleDeletePopup(
              "",
              "",
              "",
              table.getSelectedRowModel().rows,
              "multipleRowInactive"
            )
          }
          startIcon={<DeleteIcon />}
          variant="contained"
        >
          Delete
        </Button>
      ) : (
        ""
      )}
      {/* <Button
      size="small"
      onClick={() =>
        // setPagination({ ...pagination, pageSize: totalRows })
        setPagination({
          ...pagination,
          pageIndex: 0,
          pageSize: totalRows,
        })
      }
      variant="contained"
    >
      Get All Data
    </Button> */}
    </Box>
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Receiving</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                {/* <li className="breadcrumb-item">
                  <Link to="/receiving">Receiving List</Link>
                </li> */}
                <li className="breadcrumb-item active">Receiving List</li>
              </ul>
            </div>
          </div>
          <div
            // className="btn-group ms-2 dropdown"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "14px",
            }}
          >
            {checkUserPermission("export-button") ? (
              <button
                // className="btn btn-added pull-right"
                className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                style={{ width: "max-content" }}
                onClick={() => onBtExport([], "AllData")}
              >
                <i
                  className="fa fa-download mr-2"
                  style={{ color: "#111930" }}
                ></i>
                Export Visible Column
                {/* <i class="fa-thin fa-download"></i> */}
              </button>
            ) : (
              ""
            )}

            <button
              className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
              style={{ width: "max-content" }}
              onClick={() => handleExportAllReceivings()}
            >
              <i
                className="fa fa-download mr-2"
                style={{ color: "#111930" }}
              ></i>
              Export All Receivings
            </button>

            {(checkUserPermission(PERMISSION_ADD) || checkUserPermission("/pos-receiving")) ? (
              <div className="me-2">
                <Link
                  // className="btn btn-added pull-right btn-sm"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  // to={`/manage-receiving`}
                  to={
                    isManageReceiving == 1
                      ? "/manage-receiving"
                      : isManagePOSReceiving == 1
                      ? "/pos-receiving"
                      : "#"
                  }
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  New Receiving
                </Link>
              </div>
            ) : (
              ""
            )}
            {checkUserPermission(PERMISSION_PAYBILLS) ? (
              <div className="me-2">
                <Link
                  // className="btn btn-added pull-right  btn-sm"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  to={`/paybills`}
                >
                  {/* <i className="fa fa-plus me-2 lg"></i> */}
                  Pay Bills
                </Link>
              </div>
            ) : (
              ""
            )}
            <div className="btn-group btn-group-sm pull-right me-2">
              {checkUserPermission(PERMISSION_TRANSFER) ||
              checkUserPermission(PERMISSION_INCOMING) ||
              // checkUserPermission(PERMISSION_PURCHASE) ||
              checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                //|| checkUserPermission(PERMISSION_BATCHRECEIVING) ||
                //  checkUserPermission(PERMISSION_CUSTOMFIELD)
                <button
                  type="button"
                  className="btn btn-outline-dark dropdown-toggle me-1  btn-sm"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  More
                </button>
              ) : (
                " "
              )}
              <ul className="dropdown-menu">
                {/* <li>
                        <Link
                          to="/suspended-receiving"
                          title="Suspended receiving"
                          className="dropdown-item"
                        >
                          <i className="far fa-file fs-6 me-1"></i> Suspended
                          Receivings And Purchase orders
                        </Link>
                      </li> */}

                {checkUserPermission(PERMISSION_TRANSFER) ? (
                  <li>
                    <Link
                      to="/transfer-request/1"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      {/* <FontAwesomeIcon icon="fa-solid fa-shuffle" /> */}
                      Transfer Request
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_INCOMING) ? (
                  <li>
                    <Link
                      to="/suspended-receiving/0"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      {/* <i className="far fa-file fs-6 me-1"></i> */}
                      Incoming Transfers
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 1365-
                {checkUserPermission(PERMISSION_PURCHASE) ? (
                  <li>
                    <Link
                      to="/create-purchase-orders"
                      title="Create Purchase Order"
                      className="dropdown-item"
                    >
                      Create Purchase Orders
                    </Link>
                  </li>
                ) : (
                  ""
                )} */}

                {checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                  <li>
                    <Link
                      // type="button"
                      className="dropdown-item"
                      data-bs-target="#LookupReceiptModal"
                      data-bs-toggle="modal"
                    >
                      {/* <i className="far fa-file fs-6 me-1"></i> */}
                      Lookup Receipt
                    </Link>
                  </li>
                ) : (
                  ""
                )}
                {/* <LookupReceiptModal /> */}

                {checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                  <li>
                    <Link
                      to="/receiving-receipt"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      {/* <i className="far fa-file fs-6 me-1"></i> */}
                      Show Last Receiving
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {/* {checkUserPermission(PERMISSION_BATCHRECEIVING) ? (
                  <li>
                    <Link
                      to="/batch-receiving"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      {/* <i className="fas fa-shopping-bag fs-6 me-1"></i> */}
                {/* Batch Receiving
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_CUSTOMFIELD) ? (
                  <li>
                    <Link
                      to={"/receiving-custom-field"}
                      className="dropdown-item"
                    >
                      {/* <i className="fas fa-wrench fs-6 me-1"></i> */}
                {/* Custom Field Configuration
                    </Link>{" "}
                  </li>
                ) : (
                  ""
                )} */}
              </ul>
            </div>
          </div>
          {/* summnery of recieving data */}

          {checkUserPermission("hide-cards") && (
            <div className="row">
              <div className="col-lg-3 col-sm-3 col-12">
                <div className="dash-widget mb-0">
                  <div className="dash-widgetimg">
                    <span>
                      <img src={Dash1} alt="img" />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">
                      <span className="p-20 counters">
                        {/* <CountUp
                          className="p-20"
                          end={recevingSummary?.PurchaseAmount}
                        /> */}
                          {CurrencySymbols(
                          Number(recevingSummary?.PurchaseAmount),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                        {/* <CountUp
                          className="p-20"
                          end={Number(recevingSummary?.PurchaseAmount)}
                          decimals={2}
                          separator=","
                          decimal="."
                          formattingFn={(value) =>
                            value.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }
                        /> */}

                        {/* <CountUp end={3000.80} /> */}
                      </span>
                    </p>
                    <p className="p-medium">
                      {recevingSummary?.PurchaseCount !== 0
                        ? recevingSummary?.PurchaseCount
                        : 0}{" "}
                      Purchase Orders
                    </p>
                    {/* <h6>{3} Estimate</h6> */}
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-2 col-sm-4 col-12">
              <div className="dash-widget dash1">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash2} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary.UnbilledActivityAmount} />
                    </span>
                  </h5>
                  <h6>{recevingSummary.UnbilledActivityCount} Unbilled Activity </h6>
                </div>
              </div>
            </div> */}
              <div className="col-lg-3 col-sm-3 col-12">
                <div className="dash-widget dash2  mb-0">
                  <div className="dash-widgetimg">
                    <span>
                      <img src={Dash3} alt="img" />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">
                      <span className="p-20 counters">
                        {/* <CountUp
                          className="p-20"
                          end={recevingSummary?.OverdueAmount}
                        /> */}
                            {CurrencySymbols(
                          Number(recevingSummary?.OverdueAmount),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                        {/* <CountUp
                          className="p-20"
                          end={Number(recevingSummary?.OverdueAmount)}
                          decimals={2}
                          separator=","
                          decimal="."
                          formattingFn={(value) =>
                            value.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }
                        /> */}
                      </span>
                    </p>
                    <p className="p-medium">
                      {recevingSummary?.OverdueCount !== 0
                        ? recevingSummary?.OverdueCount
                        : 0}{" "}
                      Overdue
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-12">
                <div className="dash-widget dash3  mb-0">
                  <div className="dash-widgetimg">
                    <span>
                      <img src={Dash4} alt="img" />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">
                      <span className="p-20 counters">
                        {/* <CountUp
                          className="p-20"
                          end={recevingSummary?.UnbilledActivityAmount}
                        /> */}
                            {CurrencySymbols(
                          Number(recevingSummary?.UnbilledActivityAmount),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                        {/* <CountUp
                          className="p-20"
                          end={Number(recevingSummary?.UnbilledActivityAmount)}
                          decimals={2}
                          separator=","
                          decimal="."
                          formattingFn={(value) =>
                            value.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }
                        /> */}
                      </span>
                    </p>
                    <p className="p-medium">
                      {recevingSummary?.UnbilledActivityCount !== 0
                        ? recevingSummary?.UnbilledActivityCount
                        : 0}{" "}
                      Open Bill
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-12">
                <div className="dash-widget dash2 mb-0">
                  <div className="dash-widgetimg">
                    <span>
                      <img src={Dash2} alt="img" />
                      {/* <img src={Dash4} alt="img" /> */}
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">
                      <span className="p-20 counters">
                        {/* <CountUp
                          className="p-20"
                          end={recevingSummary?.LastPaidCountAmount}
                        /> */}
                            {CurrencySymbols(
                          Number(recevingSummary?.LastPaidCountAmount),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                        {/* <CountUp
                          className="p-20"
                          end={Number(recevingSummary?.LastPaidCountAmount)}
                          decimals={2}
                          separator=","
                          decimal="."
                          formattingFn={(value) =>
                            value.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }
                        /> */}
                      </span>
                    </p>
                    <p className="p-medium">
                      {recevingSummary?.LastPaidCount !== 0
                        ? recevingSummary?.LastPaidCount
                        : 0}{" "}
                      Paid Last 30 Days
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* filteration of table data */}
          <div className="row">
            <div className="d-flex justify-content-between mb-2">
              <div className="d-flex mb-2">
                {/* <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                Search:
                <input
                  type="search"
                  placeholder="Search..."
                  className=" form-control form-control-sm"
                  onChange={ChangeFilterText}
                  value={searchtext}
                  width="1rem"
                />
              </div> */}
                <div className="pr-2 col-lg-4 col-md-5 col-sm-12">
                  Date Filter:
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange(event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    // isClearable={true}
                    // hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  // <>
                  <div className="pr-2 col-lg-2 col-md-5 col-sm-12">
                    Custom Start Date:
                    {/* <Flatpickr
                      type="date"
                      className="form-control form-control-sm mt-1"
                      id="StartDate"
                      name="StartDate"
                      value={
                        moment(customStartingDate).format(
                          "YYYY-MM-DDT00:00:00.000"
                        ) + "Z"
                      }
                      onChange={(event) =>
                        handleChangeCustomStartingDate(event)
                      }
                        options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                    /> */}
                    <CommonDatePicker
                      FinalDate={customStartingDate}
                      handleDateChange={handleChangeCustomStartingDate}
                    />
                  </div>
                )}
                {quickBookOptions?.value == 2 && (
                  <div className="pr-2 col-lg-2 col-md-5 col-sm-12">
                    Custom End Date:
                    {/* <Flatpickr
                      type="date"
                      className="form-control form-control-sm mt-1"
                      id="EndDate"
                      name="EndDate"
                      value={
                        moment(customEndingDate).format(
                          "YYYY-MM-DDT00:00:00.000"
                        ) + "Z"
                      }
                      onChange={(event) => handleChangeCustomEndingDate(event)}
                        options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                    /> */}
                    <CommonDatePicker
                      FinalDate={customEndingDate}
                      handleDateChange={handleChangeCustomEndingDate}
                    />
                  </div>
                )}
                {quickBookOptions?.value == 2 && (
                  <div className="pr-2 col-lg-1 col-md-6 col-sm-12 mt-4 mr-4 ">
                    <button
                      className="btn btn-dark btn-sm mt-1"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      {" "}
                      <i class="fa fa-search"></i>{" "}
                    </button>
                  </div>
                )}
                {/* </> */}
                {/* )} */}
                {/* <div className="p-3 col-lg-1 col-md-6 col-sm-12 mt-4">
                  <button
                    className="btn btn-dark"
                    onClick={() => handleSearchAccordingToDate()}
                  >
                    {" "}
                    Search{" "}
                  </button>
                </div> */}
                <div className="pr-2 col-lg-4 col-md-6 col-sm-12">
                  Receiving Type:
                  <Select
                    // defaultValue={receivingTypeValue}
                    onChange={(event) => {
                      handleChangeReceivingType(event);
                    }}
                    value={receivingTypeDropdownOption?.find(
                      (el) => el.value == receivingTypeID
                    )}
                    options={receivingTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                  />
                </div>
                <div className="pr-2 col-lg-5 col-md-6 col-sm-12">
                  Supplier:
                  <Select
                    defaultValue={supplierValue}
                    onChange={(event) => {
                      handleChangeSupplier(event);
                    }}
                    options={supplierDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                    filterOption={(candidate, input) => {
                      const searchText = input.toLowerCase();
                      const {label,address, PhoneNumber } = candidate.data; // Access additional fields
                      return (
                        label?.toLowerCase().includes(searchText) ||
                        address?.toLowerCase().includes(searchText) || 
                        PhoneNumber?.toLowerCase().includes(searchText) 
                      );
                    }}
                  />
                </div>
                <div className="pr-2 col-lg-4 col-md-6 col-sm-12">
                  Status:
                  <Select
                    // defaultValue={status}
                    onChange={(event) => {
                      handleChangeStatus(event);
                    }}
                    value={statusoption?.find((el) => el.value == status)}
                    options={statusoption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    // isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                  />
                </div>
              </div>
              <div
                className="mt-4 cursor-pointer"
                onClick={() =>
                  handleSaveColumnOrder(
                    loginuserid,
                    "receivings",
                    columnOrder,
                    token,
                    columnVisibility
                  )
                }
                title="Lock Your Sequence"
                // onMouseEnter={() => setIcon(ColumnOrderIconHover)}
                // onMouseLeave={() => setIcon(ColumnOrderIcon)}
              >
                <i class="fa fa-lock columnsLock fs-4"></i>
              </div>
            </div>
            {/* <div className="col-lg-10 col-md-10 col-sm-12"></div> */}
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div style={{ position: "relative", zIndex: "0" }}>
                <div className="table-responsive">
                  <CommonMatrialReactTableServerSideRender
                    MainHeading="Sonar POS"
                    ReportHeading="Receiving List"
                    columns={columns}
                    data={data}
                    // startdate={startdate}
                    // enddate={enddate}
                    columnGrouping={[]}
                    columnsVisibility={{}}
                    enableRowActions={
                      checkUserPermission(PERMISSION_DELETE) ||
                      checkUserPermission(PERMISSION_EDIT) ||
                      checkUserPermission(PERMISSION_RECEIPT)
                    }
                    enableRowSelection={true}
                    renderRowActionMenuItems={renderRowActionMenuItems}
                    renderTopToolbarCustomActions={
                      renderTopToolbarCustomActions
                    }
                    density="compact"
                    showGlobalFilter={true}
                    showColumnFilters={false}
                    expanded={true}
                    pagination={{ pageIndex: 0, pageSize: 25 }}
                    rowCount={totalRows}
                    setColumnFilters={setColumnFilters} // for termp comment filteron column
                    setGlobalFilter={setGlobalFilter}
                    setPagination={setPagination}
                    setSorting={setSorting}
                    setColumnOrder={setColumnOrder}
                    setColumnVisibility={setColumnVisibility} //setColumnVisibility
                    state={{
                      columnFilters, // for termp comment filteron column
                      // globalFilter,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                      columnOrder,
                      columnVisibility,
                    }}
                  />

                  {/* <MaterialReactTable
                  columns={columns}
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableColumnOrdering
                  enableRowActions={
                    checkUserPermission(PERMISSION_DELETE) ||
                    checkUserPermission(PERMISSION_EDIT) ||
                    checkUserPermission(PERMISSION_RECEIPT)
                  }
                  enableRowSelection
                  // positionToolbarAlertBanner= 'head-overlay'
                  renderRowActionMenuItems={({ row }) => [
                    checkUserPermission(PERMISSION_PAYBILLS) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"
                        onClick={() => {
                          localStorage.setItem(
                            "paybillSupplierid",
                            row.original.SupplierId
                          );
                          navigate("/receiving-paybills");
                        }}
                      >
                        Mark As Paid
                      </MenuItem>
                    ) : (
                      ""
                    ),

                    checkUserPermission(PERMISSION_EDIT) ? (
                      row.original.ReceivingTypeId == 4 &&
                      row.original.Status == 2 ? (
                        ""
                      ) : (
                        <MenuItem
                          key="edit"
                          onClick={() =>
                            navigate(
                              `/manage-receiving/${row.original.ReceivingId}`
                            )
                          }
                        >
                          Edit
                        </MenuItem>
                      )
                    ) : (
                      ""
                    ),

                    checkUserPermission(PERMISSION_DELETE) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"

                        // title="Delete"
                        // data-bs-toggle="modal"
                        // data-bs-target="#DeleteConfirmationModal"
                        onClick={() =>
                          handleDeletePopup(
                            row.original.ReceivingId,
                            row.original.QuickbookId,
                            row.original.ReceivingTypeId,
                            row.original.SupplierId,
                            "",
                            ""
                          )
                        }
                      >
                        Delete
                      </MenuItem>
                    ) : (
                      ""
                    ),

                    checkUserPermission(PERMISSION_RECEIPT) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"
                        onClick={() =>
                          navigate(
                            `/receiving-receipt/${row.original.ReceivingId}`
                          )
                        }
                      >
                        Receipt
                      </MenuItem>
                    ) : (
                      ""
                    ),
                  ]}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "0.2rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                        width: "70%",
                        marginLeft: "30px",
                      }}
                    >
                      {(table.getIsSomeRowsSelected() ||
                        table.getIsAllRowsSelected()) &&
                      checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                          // size="small"
                          class="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          // disabled={
                          //   !table.getIsSomeRowsSelected() &&
                          //   !table.getIsAllRowsSelected()
                          // }
                          onClick={() =>
                            handleDeletePopup(
                              "",
                              "",
                              "",
                              table.getSelectedRowModel().rows,
                              "multipleRowInactive"
                            )
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          Delete
                        </Button>
                      ) : (
                        ""
                      )} 
                    </Box>
                  )}
                  muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                  initialState={{
                    density: "comfortable",
                    showGlobalFilter: true,

                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                  // muiTableContainerProps={{ sx: { maxHeight: 700 } }}

                  //For color of each alternative row(Zebra-column)
                  muiTableBodyProps={{
                    sx: () => ({
                      "& tr:nth-of-type(even)": {
                        backgroundColor:
                          "var(--datatable-row-background-color)",
                        //'rgb(237 237 233 / 63%)'
                      },
                      "& td": {
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },

                      "& tr": {
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },
                    }),
                  }}
                  muiPaginationProps={{
                    rowsPerPageOptions: [
                      25, 50, 100, 300, 500, 1000, 2000, 5000, 10000,
                    ],
                  }}
                  // For providing margin to each column
                  muiTableBodyCellProps={{
                    sx: { borderLeft: "1px solid #E0E0E0" },
                  }}
                  // For providing color to header of table
                  muiTableHeadCellProps={{
                    sx: (theme) => ({
                      background: "var(--datatable-row-background-color)", //'#e9e9e9',
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  manualFiltering // for termp comment filteron column
                  manualPagination
                  positionGlobalFilter="left" //search filter to the left
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  rowCount={rowCount}
                  onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  onColumnOrderChange={setColumnOrder}
                  onColumnVisibilityChange={setColumnVisibility}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    columnFilters, // for termp comment filteron column
                    // globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                    columnOrder,
                    columnVisibility
                  }}
                /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LookupReceiptModal />
      <DeleteConfirmationModal
        deleteApiUrl={`${config.receivingBaseUrl}/receivings/batchdelete`}
        open={deleteModalOpen}
        // quickbookarray={quickbookarray}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default Receiving;
